<template>
  <div class="mdc-select-field-container">
    <div
      class="mdc-select"
      :class="styleClasses"
    >
      <i class="mdc-select__dropdown-icon" />
      <select
        :id="id"
        :name="name"
        class="mdc-select__native-control"
        :value="value"
        :required="required"
        :disabled="disabled"
        @input="onInput"
      >
        <option
          value=""
          :disabled="!allowNoSelection"
          selected
        />
        <option
          v-for="option in options"
          :key="option[idKey]"
          :value="option[valueKey]"
          v-text="option[labelKey]"
        />
      </select>

      <div class="mdc-notched-outline">
        <div class="mdc-notched-outline__leading" />
        <div class="mdc-notched-outline__notch">
          <label
            class="mdc-floating-label"
            :class="labelStyleClasses"
            v-text="label"
          />
        </div>
        <div class="mdc-notched-outline__trailing" />
      </div>
    </div>

    <mdc-text-field-helper-text :help-message="helpText" />
  </div>
</template>

<script>
// import * as _ from 'lodash'

// https://material.io/develop/web/components/input-controls/select-menus/
import { MDCSelect } from '@material/select'
import MdcTextFieldHelperText from './TextFieldHelperText'

export default {
  name: 'MaterialSelectField',
  components: {
    MdcTextFieldHelperText
  },
  props: {
    id: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    idKey: {
      type: String,
      default: 'id'
    },
    labelKey: {
      type: String,
      default: 'label'
    },
    valueKey: {
      type: String,
      default: 'value'
    },
    options: {
      type: Array,
      required: true
    },
    name: {
      type: String,
      default: undefined
    },
    outlined: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    helpText: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    leadingIcon: {
      type: Boolean,
      default: false
    },
    allowNoSelection: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      initializationRequired: false
    }
  },
  computed: {
    styleClasses () {
      return {
        'mdc-select--outlined': this.outlined,
        'mdc-select--with-leading-icon': this.leadingIcon
      }
    },
    labelStyleClasses () {
      return {
        // 'mdc-floating-label--float-above': !!this.value
      }
    }
  },
  watch: {
    value (val) {
      this.mdcTextSelectField.value = val
      this.mdcTextSelectField.valid = true
    }
  },
  mounted () {
    this.initMDC()
  },
  destroyed () {
    this.destroyMDC()
  },
  methods: {
    initMDC () {
      this.mdcTextSelectField = new MDCSelect(this.$el.querySelector('.mdc-select'))
    },
    destroyMDC () {
      this.mdcTextSelectField && this.mdcTextSelectField.destroy()
    },
    onInput () {
      this.$emit('input', this.mdcTextSelectField.value)
    }
  }
}
</script>

<style lang="scss">
@import "./variables";
@import "@material/select/mdc-select";

.mdc-select {
  width: 100%;
}
</style>
